export default "/images/Privaposts-Phone-icon.png?8c22413b4379c677d88c892c2f96916e";